import {
  buildServices
} from './utils/build_services'
import { CONTENT } from '@/services/axios.config'

const services = [
  {
    name: 'listRelatedContent',
    method: 'post',
    url: () => `/related-content`,
    data: (params) => {
      return {
         uuid_list: params.ids
      }
    },
  }
]

export const {
  listRelatedContent,
} = buildServices(CONTENT, services)
